<template>
  <!--
        作者：rj_wu
        时间：2023-12-14
        描述：插件中心-授信管理
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="depositName">
     
      <el-tab-pane label="授信额度" name="credit"></el-tab-pane>
      <el-tab-pane label="授信明细" name="log"></el-tab-pane>
      <el-tab-pane label="基础设置" name="setting"></el-tab-pane>
    </el-tabs>
    <Setting v-if="depositName == 'setting'"></Setting>
    <Credit v-if="depositName == 'credit'"></Credit>
    <Log v-if="depositName == 'log'"></Log>
  </div>
</template>
<script>
import Credit from "./credit";
import Log from "./log";
import Setting from "./setting";
export default {
  components: {
    Credit,
    Log,
    Setting,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0,
      },
      depositName: "credit",
    };
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/credit/index.vue